import { Card } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { getProgramTypes } from "../../data/enums";
import boardOrUniversityService from "../../services/boardOrUniversityService";
import instituteService from "../../services/instituteService";
import logger from "../../services/logger";
import programService from "../../services/programService";
import OrgContext from "../app-context";
import { getDynamicFormJson } from "../common/dynamicFormService";
import Form from "../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../common/formUtils";

import programJson from "./program.json"

class ProgramForm extends Form {
  constructor() {
    super();
   
    this.formJson = programJson;

    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }

  getBoardOrUniversities = async () => {
    try {
      const { data } = await boardOrUniversityService.getBoardOrUniversities();

      const dropDowns = { ...this.state.dropDowns };
      dropDowns.boardOrUniversities = data;
      this.setState({ dropDowns });
    } catch (ex) {
      logger.error(ex);
    }
  };

  getInstitutes = async () => {
    try {
      const { data } = await instituteService.getInstitutes();

      const dropDowns = { ...this.state.dropDowns };
      dropDowns.institutes = data;
      this.setState({ dropDowns });
    } catch (ex) {
      logger.error(ex);
    }
  };



  getEnumValues = async () => {
   
    const org = await this.context;
    //console.log("orga========:", org);
    const programTypes = getProgramTypes(org.instituteType)

    const dropDowns = { ...this.state.dropDowns };
    dropDowns.programTypes = programTypes;
    this.setState({ dropDowns });
  };

  async populateForm() {
    const id = this.props.id;
    if (id === "new") return;
    try {
      
      const { data } = await programService.get(id);

      this.mapToViewModel(data);
    } catch (ex) { }
  }

  async componentDidMount() {
    this.getEnumValues();

    await this.populateForm();
  }

  doSubmit = async (id) => {
    try {
    
      if (id === "new") await programService.create(this.state.data);
      else await programService.update(this.state.data);
      this.props.onSave();
    } catch (ex) {
      // logger.log(ex.response.data.message);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.id;

    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);
    return (
      <Card>
          {/* <CardHeader title={t(titleText)} action={<BackButton {...this.props} />} /> */}
        <form onSubmit={(event) => this.handleSubmit(event, id)}>

          {this.renderForm(this.formJson, dropDowns)}

        </form>
      </Card>
    );
  }
}
ProgramForm.contextType = OrgContext;
export default withTranslation(["program", "common"])(ProgramForm);
